// Single source of truth for evaluating a user's data policies.
//
// The API returns them at `accounts[0].policies[]`, each shaped like:
//   { status, data_policy: { uuid, target_users, is_acceptance_required } }
//
// A mandatory policy is one that targets end-users and must be accepted.
// It counts as "missing" until its status is explicitly 'accepted'.

const targetsUsers = (policy) =>
  policy?.data_policy?.target_users?.indexOf('users') > -1;

const isRequired = (policy) =>
  targetsUsers(policy) && policy?.data_policy?.is_acceptance_required === true;

// Mandatory user policies the account has not accepted yet.
export const getMissingRequiredPolicies = (policies = []) =>
  (policies || []).filter(
    (policy) => isRequired(policy) && policy?.status !== 'accepted'
  );

// True when the account still has mandatory policies to accept.
export const hasMissingRequiredPolicies = (policies = []) =>
  getMissingRequiredPolicies(policies).length > 0;

// Pre-fills the terms form: one { data_policy_uuid, status } entry per policy.
// User-targeted policies with no status yet default to 'false' (unticked).
export const buildPolicySelection = (policies = []) =>
  (policies || []).map((policy) => ({
    data_policy_uuid: policy?.data_policy?.uuid,
    status:
      targetsUsers(policy) && policy?.status == undefined
        ? 'false'
        : policy?.status,
  }));
